import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';

import authReducer from './auth/reducers';
import appsReducer from './apps/reducers';
import infoReducer from './infos/reducers';
import adminsReducer from './admins/reducers';
import pointsReducer from './points/reducers';
import trailsReducer from './trails/reducers';
import uiReducer from './ui/reducers';
import typesReducer from './types/reducers';
import customFieldsReducer from './customfields/reducers';
import commentsReducer from './comments/reducers';
import mediaTypesReducer from './mediatypes/reducers';
import reportsReducer from './reports/reducers';
import reportsubjectsReducer from './reportsubjects/reducers';
import newsReducer from './news/reducers';
import pagesReducer from './pages/reducers';
import achievementsReducer from './achievements/reducers';
import roadbookconfigurationsReducer from './roadBookConfigurations/reducers';
import quizzesReducer from './quizzes/reducers';
import userAchievementsReducer from './userachievements/reducers';
import accessTokenReducer from './accessTokens/reducers';

const reducers = combineReducers({
    ui: uiReducer,
    trails: trailsReducer,
    points: pointsReducer,
    apps: appsReducer,
    auth: authReducer,
    admins: adminsReducer,
    info: infoReducer,
    types: typesReducer,
    customFields: customFieldsReducer,
    comments: commentsReducer,
    mediaTypes: mediaTypesReducer,
    reports: reportsReducer,
    reportsubjects: reportsubjectsReducer,
    roadBookConfigurations: roadbookconfigurationsReducer,
    news: newsReducer,
    pages: pagesReducer,
    achievements: achievementsReducer,
    quizzes: quizzesReducer,
    form: formReducer,
    userAchievements: userAchievementsReducer,
    accessTokens: accessTokenReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export default store;



// WEBPACK FOOTER //
// src/store/index.js